import React from 'react';
import {RouteHandler} from 'react-router';

import initApplication from '../utils/initApplication';
import PageError from '../views/PageError';

import Notifications from '../components/Notifications';


@initApplication(PageError)
class Wrapper extends React.Component {
    render() {
        return (
            <div>
                <Notifications notificationStore={this.props.notifications} />
                <RouteHandler {...this.props} />
            </div>
        );
    }
}

export default Wrapper;



/** WEBPACK FOOTER **
 ** ./app/src/views/Wrapper.js
 **/